<template>
    <div class="pdf-document">
        <PDFPage v-for="page in pages" :key="page.pageNumber" :page="page" />
    </div>
</template>

<script>
    import debug from 'debug';
    const log = debug('app:components/PdfViewer');

    import PDFPage from './PdfPage.vue';
    import range from 'lodash/range';

    export default {
        components: {
            PDFPage
        },
        props: {
            url: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                pdf: undefined,
                pages: []
            }
        },
        methods: {
            fetchPDF() {
                import('pdfjs-dist/webpack')
                    .then(pdfjs => pdfjs.getDocument(this.url))
                    .then(pdf => (this.pdf = pdf));
            }
        },
        watch: {
            pdf: {
                handler(pdf) {
                    const promises = range(1, 2).map(number => pdf.getPage(number));
                    return Promise.all(promises).then(pages => (this.pages = pages)).then(() => log('pages fetched'))
                }
            }
        },
        created() {
            this.fetchPDF();
        }
    }
</script>